import { Controller } from "@hotwired/stimulus";

/**
 * ChatKit Toggle Controller
 *
 * Handles opening and closing the ChatKit panel.
 * Works with Alpine.js for transitions and Turbo Frame for persistence.
 */
export default class extends Controller {
  toggle(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // Dispatch custom event that Alpine.js can listen to
    globalThis.dispatchEvent(new CustomEvent('toggle-chatkit'));
  }
}
